import { EntityType } from 'common/enums/entity-enums.js';
import { IObject } from 'common/interfaces/hierarchy-entities.js';

type NameResolver = (associatedData: any) => string;

const associatedDataNameResolveMap = new Map<string, NameResolver>([
  [EntityType.SurveyRun, (associatedData) => associatedData?.surveyRunName],
]);

export function resolveAssociatedDataName(object: IObject, associatedData: any): string {
  const nameResolver = associatedDataNameResolveMap.get(object?.type as EntityType);
  return nameResolver?.(associatedData) ?? object?.name;
}
